/**
 * Clases de color del badge "Días sin pago".
 * Menos de 30 días va en verde, de 30 a 60 en ámbar y más de 60 en rojo.
 * `Badge` no tiene variante ámbar, así que las tres bandas van por className, cada una con su variante dark.
 */
export function claseBadgeDiasSinPago(dias: number): string {
  if (dias > 60) return 'border-transparent bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300'
  if (dias >= 30) return 'border-transparent bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300'
  return 'border-transparent bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300'
}
